export default class PostFilterSelect {
    constructor() {
        const formSelectors = ['form#category', 'form#our-people', 'form#filter-form'];

        formSelectors.forEach((formSelector) => {
            const $form = $(formSelector);
            if (!$form.length) return;

            const $selects = $form.find('.js-select');
            if (!$selects.length) return;

            // Reinitialize Select2 with dropdownParent to prevent focus loss
            // which causes the dropdown to close immediately on click
            $selects.each(function () {
                if ($(this).data('select2')) {
                    $(this).select2('destroy');
                }
            });
            $selects.select2({
                minimumResultsForSearch: Infinity,
                width: '100%',
                dropdownParent: $form
            });
        });
    }
}

new PostFilterSelect();
